import { normalize, schema } from "normalizr";

export const normalizeConversation = (originalConversation) => {
  const lastMessage = new schema.Entity("messages");
  const conversationOpponent = new schema.Entity("conversationOpponents");
  const conversationSchema = new schema.Entity("conversations", {
    conversationOpponent,
    lastMessage,
  });

  return normalize(originalConversation, conversationSchema);
};

export const normalizeConversationsArray = (originalConversations) => {
  const lastMessage = new schema.Entity(
    "messages",
    {},
    { idAttribute: (value) => value?.uuid || value.id },
  );
  const lastMessageUuid = new schema.Entity("messages");
  const conversationOpponent = new schema.Entity("conversationOpponents");
  const conversationSchema = new schema.Entity("conversations", {
    conversationOpponent,
    lastMessage,
    lastMessageUuid,
  });

  const conversations = new schema.Array(conversationSchema);

  return normalize(originalConversations, conversations);
};

export const normalizeMessage = (originalMessages) => {
  const post = new schema.Entity("post");
  const message = new schema.Entity("messages", { post });

  return normalize(originalMessages, message);
};

export const normalizeMessages = (originalMessage) => {
  const post = new schema.Entity("post");

  const message = new schema.Entity(
    "messages",
    {
      post,
    },
    { idAttribute: (value) => value?.uuid || value.id },
  );

  const messages = new schema.Array(message);

  return normalize(originalMessage, messages);
};
